<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
  @import '~bootstrap-vue/dist/bootstrap-vue.css';

  @import 'assets/styles.css';

</style>
